module.exports = __webpack_public_path__ + "static/media/icon_apple-store.34a93f27.svg";